import React from 'react';
import Select from 'react-select';

const AiReportTypeField = ({
  value,
  onChange,
  options = [],
  styles,
  label = 'AI Report Type',
  placeholder = 'Select report type',
  isClearable = true,
}) => {
  const selectedOption = options.find((option) => option.value === value) || null;

  return (
    <div className="form-section">
      <div className="form-section-title">
        <span className="form-section-title-text">{label}</span>
      </div>
      <div className="form-item">
        <Select
          options={options}
          value={selectedOption}
          onChange={(option) => onChange?.(option ? option.value : null)}
          placeholder={placeholder}
          isClearable={isClearable}
          styles={styles}
        />
      </div>
    </div>
  );
};

export default AiReportTypeField;
